module.exports = __webpack_public_path__ + "fonts/electra_bc9c268cd4f3a456ca4c5d5d089d2799.ttf";